module.exports = __webpack_public_path__ + "img/avatar.1343ffb8.png";